import { render, staticRenderFns } from "./RegisterDesktop.vue?vue&type=template&id=32686221&scoped=true"
import script from "./RegisterDesktop.vue?vue&type=script&lang=js"
export * from "./RegisterDesktop.vue?vue&type=script&lang=js"
import style0 from "./RegisterDesktop.vue?vue&type=style&index=0&id=32686221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32686221",
  null
  
)

export default component.exports